import { actionTypes } from "../actions/OrgRuntimeActions";

const initialState = {
  loading: false,
  runtime: {
    _trackFields: {},
    _albumFields: {},
    _trackMusicOrigins: {},
    _albumMusicOrigins: {},
    _settingMusicSearch: {},
    _settingSearchFields: {},
    _settingSearchOrigin: {},
    _settingSearchAllTagTypes: {},
    _settingSearchShowAllTagTypes: {},
    _settingSearchAllFields: {},
    _settingAllKeyFields: {},
    _settingSearchShowAllFields: {},
    _settingSearchShowGlobalQ: {},
    _settingMusicResultSingleViewCols: {},
    _settingMusicResultMultiViewCols: {},
    _settingMusicResult: {},
    _settingMusicResultRankingType: {},
    _settingSearchShowUserPref: {},
    _settingSearchUserPrefFields: {},
    _settingSearchUserPrefCanSave: {},
    _settingMusicSearchPref: {},
    DiscreteConfig: {},
    _trackAllFields: {},
    _settingMetadataConditional: {},
    _settingMetadataFieldsDefault: {},
    _settingMetadataFieldsCommercial: {},
    _settingMetadataFieldsCommissioned: {},
    _settingMetadata: {},
    _canPreviewOptions: {},
    _canPreview: {},
    _canDownloadOptions: {},
    _canDownloadMp3: {},
    _canDownloadHighres: {},
    _canPreview30Seconds: {},
    _clearanceExemptions: {},
    _mlPlayer: {},
    _mlPlPromoAdmin: {},
    _mlPlaylistsAdd: {},
    _mlPlaylistsShare: {},
    _mlPlaylistsDownload: {},
    _mlPlaylistsShareFull: {},
    _mlCanManagePlaylists: {},
    _mlPlaylists: {},
    _playouts: {},
    _manageMlUsers: {},
    _manageMlGroups: {},
    _manageMlRoles: {},
    _manageMlSettings: {},
    _manageMlAlbumRank: {},
    _manageMlTrackRank: {},
    _manageMlPlaylistCategory: {},
    _manageMlActivityLimit: {},
    _manageMlHelp: {},
    _manageMlNews: {},
    _manageMlContacts: {},
    _mlAdmin: {},
    _librarySearchHistory: {},
    _libraryResultView: {},
    _libraryAdvSearchType: {},
    _libraryRankingType: {},
    _libraryExcludeRestricted: {},
    _libraryCanSeeAllContent: {},
    _libraryCanHideUnhideTracks: {},
    _libraryCanSeeHidenTracks: {},
    _mlLibraries: {},
    _newSearchTypeSetting: {},
    _newAlbumSearchTypeSetting: {},
    _newMetadataTypeSetting: {},
    _settingAlbumSearchShowAllTagTypes: {},
    _settingAlbumSearchAllFields: {},
    _settingAlbumSearchAllTagTypes: {},
    _settingAlbumSearchOrigin: {},
    _settingAlbumSearchFields: {},
    _settingAlbumAllKeyFields: {},
    _settingAlbumMusicSearch: {},
    _settingAlbumMusicResultSingleViewCols: {},
    _settingAlbumMusicResultMultiViewCols: {},
    _settingAlbumMusicResultRankingType: {},
    _settingAlbumMusicResult: {},
    _settingAlbumMusicSearchPref: {},
    _settingAlbumSearchShowUserPref: {},
    _settingAlbumSearchUserPrefFields: {},
    _settingAlbumSearchUserPrefCanSave: {},
    _settingAlbumMetadataConditional: {},
    _settingAlbumMetadataFieldsDefault: {},
    _settingAlbumMetadataFieldsLibrary: {},
    _settingAlbumMetadataFieldsCommercial: {},
    _settingAlbumMetadataFieldsCommissioned: {},
    _settingAlbumMetadata: {},
    _newAlbumMetadataTypeSetting: {},
    orgSettingType: {},
    albumAllFields: [],
    albumDefaultFields: [],
    trackDefaultFields: [],
    T_Major: "",
    T_Branch: "",
    T_LeafBool: "",
    T_LeafOptionsSingle: "",
    T_LeafOptionsMulti: "",
    T_LeafOptionsMultiOrdered: "",
    musicOrigins: {},
    _librarySearchHistoryOptions: {},
    searchProfiles: {},
    timeSorts: {},
    viewerTypes: {},
    resultViews: {},
    _settingAlbumSearchShowGlobalQ: {},
    _canAddContent: {},
    _canCreateContentRequest: {},
    _canRequestResponse: {},
    _Messages: {},
    _contentRequest: {},
    _canCreateContentAlert: {},
    _canCreateContentAlert: {},
    _albumSearchHistoryOptions: {},
    _albumSearchHistory: {},
    albumresultViews: {},
    _albumResultView: {},
    _albumAdvSearchType: {},
    _albumRankingType: {},
    _mlAlbums: {},
    _roleSmSysAdmin: {},
    _roleMlAdmin: {},
    _roleMlContentAdmin: {},
    _roleMlProducer: {},
    _roles: {},
    _manageUsers: {},
    _seeAppLogs: {},
    _manageOrganizations: {},
    _smSysAdmin: {},
    _mlContentCanEditTracksAndAlbums: {},
    _mlContentCanDeleteTracks: {},
    _mlContentCanAddNotes: {},
    _mlContentCanCreateAdminNotes: {},
    _mlContentCanCreatePublicNotes: {},
    _mlContentCanManageRestricted: {},
    _mlContentCanManagePreRelease: {},
    _mlContentCanArchive: {},
    _mlContentCanExplicitContent: {},
    _mlContentAdmin: {},
    _trackMetadataConfig: {},
    _albumMetadataConfig: {},
    _canSeeAdminNotes: {},
    _canDownloadMetadataXML: {},
    _mlMetadata: {},
    _mlLicensingWorkflowPermissionOptions: {},
    _mlLicensingDefinitiontoCfOwnOptions: {},
    _mlLicensingUserGroupPermission: {},
    _mlLicensingUserGroupPermissionOptions: {},
    _mlCfSharePermissionOptionsID: {},
    _mlCfSharePermissionOptions: [],
    _mlLicensingCanShareCFOptions: {},
    _mlLicensingCanCreateOptions: {},
    _mlLicensingCanCreate: {},
    _mlLicensingCanCreateLimitations: {},
    _mlLicensingCanCreateLimitOptions: {},
    _mlLicensingCanRunWizard: {},
    _mlLicensingCanRunWizardOptions: {},
    _mlLicensingFormAll: {},
    _mlLicensingFormAllOptions: {},
    _mlLicensingDefinitiontoCfOwn: {},
    _mlLicensingTrackAll: {},
    _mlLicensingTrackAllOptions: {},
    _mlLicensingDefinitionToTrackOwnOptions: {},
    _mlLicensingDefinitionToTrackOwn: {},
    _mlLicensingOverideRestrictions: {},
    _mlLicensingOverideRestrictionsOptions: {},
    _mlLicensingDefinitionToOverideRestrictionsOwn: {},
    _mlLicensingDefinitiontoOverideRestrictionsOwnOptions: {},
    _mlLicensingWorkflowAdmin: {},
    _mlLicensingWorkflowPermission: {},
    _mlLicensingCanAddToPPL: {},
    _mlLicensingUserGroupList: {},
    _mlLicensingCFTypeUserGroupRestrictions: {},
    _mlLicensingCanShareCF: {},
    _mlLicensing: {},
    _manageMlLiStatuses: {},
    _manageMlLiParams: {},
    _manageMlLiRules: {},
    _canRaiseContentAlert: {},
    _mlLicensingAdmin: {},
    _plContentSharePlaylistAdd: {},
    _plContentSharePlaylistShare: {},
    _plContentSharePlaylistShareFull: {},
    _plContentSharePlaylistDownload: {},
    _plContentShareCanManagePlaylist: {},
    _mlPlaylistContentShare: {},
    _allUserAddEdit: {},
    _TrackColumns: {},
    _CFColumns: [],
    allCfColumns: [],
    _AlbumColumns: {},
    _canSeeReports: {},
    _smReports: {},
    _uploads: {},
    _canSeeLog: {},
    _smLog: {},
    _smContentAdmin: {},
    _settingMetadataFieldsLibrary: {},
    commercialMusicOrigins: [],
    productionLibMusicOrigins: [],
    commisionedMusicOrigins: [],
    _extendedTrackPreviewMetadata: {},
    cfAllProgrammeTypes: [],
    cfAllTypes: [],
    dynamicApiEndpoints: [],
    noCtagSearchRules: [],
    noDynamicApiRules: [],
    _prsPopupConfig: [],
    _allUsersStatus: {},
    _userActivityCount: {},
    _userActivityLog: {},
    _contentActivityByIP: {},
    _Top1000TrackRanking: {},
    _clearance: {},
    _takenDownTracks: {},
    _contentSummaryByWorkspace: {},
    _contentSummaryByLibrary: {},
    _abuseFlag: {},
    cfFormAddTracksSearchSettingId: null,
    albumSearchMusicOrigins: {},
    trackSearchMusicOrigins: {},
    fieldOriginGroup:{},
    newsVisibilityType: {},
    newsVisibilityTypeList: [],
    contactsCompanyType: {},
    contactsCompanyTypeList: [],
  },
  errors: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOADING:
      return {
        ...state,
        loading: true,
        errors: null,
        runtime: null,
      };
    case actionTypes.LOAD:
      return {
        ...state,
        errors: null,
        loading: false,
        runtime: {
          _trackFields: action.payload._trackFields || {},
          _albumFields: action.payload._albumFields || {},
          _trackMusicOrigins: action.payload._trackMusicOrigins || {},
          _albumMusicOrigins: action.payload._albumMusicOrigins || {},
          DiscreteConfig: action.payload.DiscreteConfig || {},
          _settingMusicSearch: action.payload._settingMusicSearch || {},
          _settingSearchOrigin: action.payload._settingSearchOrigin || {},
          _settingSearchAllTagTypes:
            action.payload._settingSearchAllTagTypes || {},
          _settingSearchShowAllTagTypes:
            action.payload._settingSearchShowAllTagTypes || {},
          _settingSearchAllFields: action.payload._settingSearchAllFields || {},
          _settingAllKeyFields: action.payload._settingAllKeyFields || {},
          _settingSearchShowAllFields:
            action.payload._settingSearchShowAllFields || {},
          _settingSearchShowGlobalQ:
            action.payload._settingSearchShowGlobalQ || {},
          _settingSearchFields: action.payload._settingSearchFields || {},
          _settingMusicResultSingleViewCols:
            action.payload._settingMusicResultSingleViewCols || {},
          _settingMusicResultMultiViewCols:
            action.payload._settingMusicResultMultiViewCols || {},
          _settingMusicResult: action.payload._settingMusicResult || {},
          _settingMusicResultRankingType:
            action.payload._settingMusicResultRankingType || {},
          _settingSearchShowUserPref:
            action.payload._settingSearchShowUserPref || {},
          _settingSearchUserPrefFields:
            action.payload._settingSearchUserPrefFields || {},
          _settingSearchUserPrefCanSave:
            action.payload._settingSearchUserPrefCanSave || {},
          _settingMusicSearchPref: action.payload._settingMusicSearchPref || {},
          _trackAllFields: action.payload._trackAllFields || {},
          _settingMetadataConditional:
            action.payload._settingMetadataConditional || {},
          _settingMetadataFieldsDefault:
            action.payload._settingMetadataFieldsDefault || {},
          _settingMetadataFieldsCommercial:
            action.payload._settingMetadataFieldsCommercial || {},
          _settingMetadataFieldsCommissioned:
            action.payload._settingMetadataFieldsCommissioned || {},
          _settingMetadata: action.payload._settingMetadata || {},
          _canPreviewOptions: action.payload._canPreviewOptions || {},
          _canPreview: action.payload._canPreview || {},
          _canDownloadOptions: action.payload._canDownloadOptions || {},
          _canDownloadMp3: action.payload._canDownloadMp3 || {},
          _canDownloadHighres: action.payload._canDownloadHighres || {},
          _canPreview30Seconds: action.payload._canPreview30Seconds || {},
          _clearanceExemptions: action.payload._clearanceExemptions || {},
          _mlPlayer: action.payload._mlPlayer || {},
          _mlPlPromoAdmin: action.payload._mlPlPromoAdmin || {},
          _mlPlaylistsAdd: action.payload._mlPlaylistsAdd || {},
          _mlPlaylistsShare: action.payload._mlPlaylistsShare || {},
          _mlPlaylistsDownload: action.payload._mlPlaylistsDownload || {},
          _mlPlaylistsShareFull: action.payload._mlPlaylistsShareFull || {},
          _mlCanManagePlaylists: action.payload._mlCanManagePlaylists || {},
          _mlPlaylists: action.payload._mlPlaylists || {},
          _playouts: action.payload._playouts || {},
          _manageMlUsers: action.payload._manageMlUsers || {},
          _manageMlGroups: action.payload._manageMlGroups || {},
          _manageMlRoles: action.payload._manageMlRoles || {},
          _manageMlSettings: action.payload._manageMlSettings || {},
          _manageMlAlbumRank: action.payload._manageMlAlbumRank || {},
          _manageMlTrackRank: action.payload._manageMlTrackRank || {},
          _manageMlPlaylistCategory:
            action.payload._manageMlPlaylistCategory || {},
          _manageMlActivityLimit: action.payload._manageMlActivityLimit || {},
          _manageMlHelp: action.payload._manageMlHelp || {},
          _manageMlNews: action.payload._manageMlNews || {},
          _manageMlContacts: action.payload._manageMlContacts || {},
          _mlAdmin: action.payload._mlAdmin || {},
          _librarySearchHistory: action.payload._librarySearchHistory || {},
          _libraryResultView: action.payload._libraryResultView || {},
          _libraryAdvSearchType: action.payload._libraryAdvSearchType || {},
          _libraryRankingType: action.payload._libraryRankingType || {},
          _libraryExcludeRestricted:
            action.payload._libraryExcludeRestricted || {},
          _libraryCanSeeAllContent:
            action.payload._libraryCanSeeAllContent || {},
            _libraryCanHideUnhideTracks:
            action.payload._libraryCanHideUnhideTracks || {},
            _libraryCanSeeHidenTracks:
            action.payload._libraryCanSeeHidenTracks || {},
          _mlLibraries: action.payload._mlLibraries || {},
          _newSearchTypeSetting: action.payload._newSearchTypeSetting || {},
          _newAlbumSearchTypeSetting:
            action.payload._newAlbumSearchTypeSetting || {},
          _newMetadataTypeSetting: action.payload._newMetadataTypeSetting || {},
          _settingAlbumSearchShowAllTagTypes:
            action.payload._settingAlbumSearchShowAllTagTypes || {},
          _settingAlbumSearchAllFields:
            action.payload._settingAlbumSearchAllFields || {},
          _settingAlbumSearchAllTagTypes:
            action.payload._settingAlbumSearchAllTagTypes || {},
          _settingAlbumSearchOrigin:
            action.payload._settingAlbumSearchOrigin || {},
          _settingAlbumSearchFields:
            action.payload._settingAlbumSearchFields || {},
          _settingAlbumAllKeyFields:
            action.payload._settingAlbumAllKeyFields || {},
          _settingAlbumMusicSearch:
            action.payload._settingAlbumMusicSearch || {},
          _settingAlbumMusicResultSingleViewCols:
            action.payload._settingAlbumMusicResultSingleViewCols || {},
          _settingAlbumMusicResultMultiViewCols:
            action.payload._settingAlbumMusicResultMultiViewCols || {},
          _settingAlbumMusicResultRankingType:
            action.payload._settingAlbumMusicResultRankingType || {},
          _settingAlbumMusicResult:
            action.payload._settingAlbumMusicResult || {},
          _settingAlbumMusicSearchPref:
            action.payload._settingAlbumMusicSearchPref || {},
          _settingAlbumSearchShowUserPref:
            action.payload._settingAlbumSearchShowUserPref || {},
          _settingAlbumSearchUserPrefFields:
            action.payload._settingAlbumSearchUserPrefFields || {},
          _settingAlbumSearchUserPrefCanSave:
            action.payload._settingAlbumSearchUserPrefCanSave || {},
          _settingAlbumMetadataConditional:
            action.payload._settingAlbumMetadataConditional || {},
          _settingAlbumMetadataFieldsDefault:
            action.payload._settingAlbumMetadataFieldsDefault || {},
          _settingAlbumMetadataFieldsLibrary:
            action.payload._settingAlbumMetadataFieldsLibrary || {},
          _settingAlbumMetadataFieldsCommercial:
            action.payload._settingAlbumMetadataFieldsCommercial || {},
          _settingAlbumMetadataFieldsCommissioned:
            action.payload._settingAlbumMetadataFieldsCommissioned || {},
          _settingAlbumMetadata: action.payload._settingAlbumMetadata || {},
          _newAlbumMetadataTypeSetting:
            action.payload._newAlbumMetadataTypeSetting || {},
          orgSettingType: action.payload.orgSettingType || {},
          albumAllFields: action.payload.albumAllFields || [],
          albumDefaultFields: action.payload.albumDefaultFields || [],
          trackDefaultFields: action.payload.trackDefaultFields || [],
          T_Major: action.payload.T_Major,
          T_Branch: action.payload.T_Branch,
          T_LeafBool: action.payload.T_LeafBool,
          T_LeafOptionsSingle: action.payload.T_LeafOptionsSingle,
          T_LeafOptionsMulti: action.payload.T_LeafOptionsMulti,
          T_LeafOptionsMultiOrdered: action.payload.T_LeafOptionsMultiOrdered,
          musicOrigins: action.payload.musicOrigins || {},
          _librarySearchHistoryOptions:
            action.payload._librarySearchHistoryOptions || {},
          searchProfiles: action.payload.searchProfiles || {},
          timeSorts: action.payload.timeSorts || {},
          viewerTypes: action.payload.viewerTypes || {},
          resultViews: action.payload.resultViews || {},
          _settingAlbumSearchShowGlobalQ:
            action.payload._settingAlbumSearchShowGlobalQ || {},
          _canAddContent: action.payload._canAddContent || {},
          _canCreateContentRequest:
            action.payload._canCreateContentRequest || {},
          _canRequestResponse: action.payload._canRequestResponse || {},
          _Messages: action.payload._Messages || {},
          _contentRequest: action.payload._contentRequest || {},
          _canCreateContentAlert: action.payload._canCreateContentAlert || {},
          _albumSearchHistoryOptions:
            action.payload._albumSearchHistoryOptions || {},
          _albumSearchHistory: action.payload._albumSearchHistory || {},
          albumresultViews: action.payload.albumresultViews || {},
          _albumResultView: action.payload._albumResultView || {},
          _albumAdvSearchType: action.payload._albumAdvSearchType || {},
          _albumRankingType: action.payload._albumRankingType || {},
          _mlAlbums: action.payload._mlAlbums || {},
          _roleSmSysAdmin: action.payload._roleSmSysAdmin || {},
          _roleMlAdmin: action.payload._roleMlAdmin || {},
          _roleMlContentAdmin: action.payload._roleMlContentAdmin || {},
          _roleMlProducer: action.payload._roleMlProducer || {},
          _roles: action.payload._roles || {},
          _manageUsers: action.payload._manageUsers || {},
          _seeAppLogs: action.payload._seeAppLogs || {},
          _manageOrganizations: action.payload._manageOrganizations || {},
          _smSysAdmin: action.payload._smSysAdmin || {},
          _mlContentCanEditTracksAndAlbums:
            action.payload._mlContentCanEditTracksAndAlbums || {},
          _mlContentCanDeleteTracks:
            action.payload._mlContentCanDeleteTracks || {},
          _mlContentCanAddNotes: action.payload._mlContentCanAddNotes || {},
          _mlContentCanCreateAdminNotes:
            action.payload._mlContentCanCreateAdminNotes || {},
          _mlContentCanCreatePublicNotes:
            action.payload._mlContentCanCreatePublicNotes || {},
          _mlContentCanManageRestricted:
            action.payload._mlContentCanManageRestricted || {},
          _mlContentCanManagePreRelease:
            action.payload._mlContentCanManagePreRelease || {},
          _mlContentCanArchive: action.payload._mlContentCanArchive || {},
          _mlContentCanExplicitContent:
            action.payload._mlContentCanExplicitContent || {},
          _mlContentAdmin: action.payload._mlContentAdmin || {},
          _trackMetadataConfig: action.payload._trackMetadataConfig || {},
          _albumMetadataConfig: action.payload._albumMetadataConfig || {},
          _canSeeAdminNotes: action.payload._canSeeAdminNotes || {},
          _canDownloadMetadataXML: action.payload._canDownloadMetadataXML || {},
          _mlMetadata: action.payload._mlMetadata || {},
          _mlLicensingWorkflowPermissionOptions:
            action.payload._mlLicensingWorkflowPermissionOptions || {},
          _mlLicensingDefinitiontoCfOwnOptions:
            action.payload._mlLicensingDefinitiontoCfOwnOptions || {},
          _mlLicensingUserGroupPermission:
            action.payload._mlLicensingUserGroupPermission || {},
          _mlLicensingUserGroupPermissionOptions:
            action.payload._mlLicensingUserGroupPermissionOptions || {},
          _mlCfSharePermissionOptionsID:
            action.payload._mlCfSharePermissionOptionsID || {},
          _mlCfSharePermissionOptions:
            action.payload._mlCfSharePermissionOptions || [],
          _mlLicensingCanShareCFOptions:
            action.payload._mlLicensingCanShareCFOptions || {},
          _mlLicensingCanCreateOptions:
            action.payload._mlLicensingCanCreateOptions || {},
          _mlLicensingCanCreate: action.payload._mlLicensingCanCreate || {},
          _mlLicensingCanCreateLimitations:
            action.payload._mlLicensingCanCreateLimitations || {},
          _mlLicensingCanCreateLimitOptions:
            action.payload._mlLicensingCanCreateLimitOptions || {},
          _mlLicensingCanRunWizard:
            action.payload._mlLicensingCanRunWizard || {},
          _mlLicensingCanRunWizardOptions:
            action.payload._mlLicensingCanRunWizardOptions || {},
          _mlLicensingFormAll: action.payload._mlLicensingFormAll || {},
          _mlLicensingFormAllOptions:
            action.payload._mlLicensingFormAllOptions || {},
          _mlLicensingDefinitiontoCfOwn:
            action.payload._mlLicensingDefinitiontoCfOwn || {},
          _mlLicensingTrackAll: action.payload._mlLicensingTrackAll || {},
          _mlLicensingTrackAllOptions:
            action.payload._mlLicensingTrackAllOptions || {},
          _mlLicensingDefinitionToTrackOwnOptions:
            action.payload._mlLicensingDefinitionToTrackOwnOptions || {},
          _mlLicensingDefinitionToTrackOwn:
            action.payload._mlLicensingDefinitionToTrackOwn || {},
          _mlLicensingOverideRestrictions:
            action.payload._mlLicensingOverideRestrictions || {},
          _mlLicensingOverideRestrictionsOptions:
            action.payload._mlLicensingOverideRestrictionsOptions || {},
          _mlLicensingDefinitionToOverideRestrictionsOwn:
            action.payload._mlLicensingDefinitionToOverideRestrictionsOwn || {},
          _mlLicensingDefinitiontoOverideRestrictionsOwnOptions:
            action.payload
              ._mlLicensingDefinitiontoOverideRestrictionsOwnOptions || {},
          _mlLicensingWorkflowAdmin:
            action.payload._mlLicensingWorkflowAdmin || {},
          _mlLicensingWorkflowPermission:
            action.payload._mlLicensingWorkflowPermission || {},
          _mlLicensingCanAddToPPL: action.payload._mlLicensingCanAddToPPL || {},
          _mlLicensingUserGroupList:
            action.payload._mlLicensingUserGroupList || {},
          _mlLicensingCFTypeUserGroupRestrictions:
            action.payload._mlLicensingCFTypeUserGroupRestrictions || {},
          _mlLicensingCanShareCF: action.payload._mlLicensingCanShareCF || {},
          _mlLicensing: action.payload._mlLicensing || {},
          _manageMlLiStatuses: action.payload._manageMlLiStatuses || {},
          _manageMlLiParams: action.payload._manageMlLiParams || {},
          _manageMlLiRules: action.payload._manageMlLiRules || {},
          _canRaiseContentAlert: action.payload._canRaiseContentAlert || {},
          _mlLicensingAdmin: action.payload._mlLicensingAdmin || {},
          _plContentSharePlaylistAdd:
            action.payload._plContentSharePlaylistAdd || {},
          _plContentSharePlaylistShare:
            action.payload._plContentSharePlaylistShare || {},
          _plContentSharePlaylistShareFull:
            action.payload._plContentSharePlaylistShareFull || {},
          _plContentSharePlaylistDownload:
            action.payload._plContentSharePlaylistDownload || {},
          _plContentShareCanManagePlaylist:
            action.payload._plContentShareCanManagePlaylist || {},
          _mlPlaylistContentShare: action.payload._mlPlaylistContentShare || {},
          _allUserAddEdit: action.payload._allUserAddEdit || {},
          _TrackColumns: action.payload._TrackColumns || {},
          _CFColumns: action.payload._CFColumns || [],
          allCfColumns: action.payload.allCfColumns || [],
          _AlbumColumns: action.payload._AlbumColumns || {},
          _canSeeReports: action.payload._canSeeReports || {},
          _smReports: action.payload._smReports || {},
          _uploads: action.payload._uploads || {},
          _canSeeLog: action.payload._canSeeLog || {},
          _smLog: action.payload._smLog || {},
          _smContentAdmin: action.payload._smContentAdmin || {},
          _settingMetadataFieldsLibrary:
            action.payload._settingMetadataFieldsLibrary || {},
          commercialMusicOrigins: action.payload.commercialMusicOrigins || [],
          productionLibMusicOrigins:
            action.payload.productionLibMusicOrigins || [],
          commisionedMusicOrigins: action.payload.commisionedMusicOrigins || [],
          _extendedTrackPreviewMetadata:
            action.payload._extendedTrackPreviewMetadata || {},
          cfAllProgrammeTypes: action.payload.cfAllProgrammeTypes || [],
          cfAllTypes: action.payload.cfAllTypes || [],
          dynamicApiEndpoints: action.payload.dynamicApiEndpoints || [],
          noCtagSearchRules: action.payload.noCtagSearchRules || [],
          noDynamicApiRules: action.payload.noDynamicApiRules || [],
          _prsPopupConfig: action.payload._prsPopupConfig || [],
          _allUsersStatus: action.payload._allUsersStatus || {},
          _userActivityCount: action.payload._userActivityCount || {},
          _userActivityLog: action.payload._userActivityLog || {},
          _contentActivityByIP: action.payload._contentActivityByIP || {},
          _Top1000TrackRanking: action.payload._Top1000TrackRanking || {},
          _clearance: action.payload._clearance || {},
          _takenDownTracks: action.payload._takenDownTracks || {},
          _contentSummaryByWorkspace:
            action.payload._contentSummaryByWorkspace || {},
          _contentSummaryByLibrary:
            action.payload._contentSummaryByLibrary || {},
          _abuseFlag: action.payload._abuseFlag || {},
          cfFormAddTracksSearchSettingId:
            action.payload.cfFormAddTracksSearchSettingId || null,
          albumSearchMusicOrigins: action.payload.albumSearchMusicOrigins || {},
          trackSearchMusicOrigins: action.payload.trackSearchMusicOrigins || {},
          fieldOriginGroup: action.payload.fieldOriginGroup || {},
          newsVisibilityType: action.payload.newsVisibilityType || {},
          newsVisibilityTypeList: action.payload.newsVisibilityTypeList || [],
          contactsCompanyType: action.payload.contactsCompanyType || {},
          contactsCompanyTypeList: action.payload.contactsCompanyTypeList || [],
        },
      };
    case actionTypes.ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload,
        runtime: null,
      };

    default:
      return state;
  }
}
